<div class="main-header" fxLayout="row" *ngIf="!creating">
    Manage Integration - {{integrationName}}
</div>
<div class="main-header" fxLayout="row" *ngIf="creating">
    Connect Integration - {{integrationName}}
</div>
<div fxLayout="column" *ngIf="currentInvite && !creating" >
    <div class="sub-header" fxLayout="row">
        <span>Integration Invite Details</span>
    </div>
    <div class="section" fxLayout="column">
        <div fxLayout="row" class="label">Name</div>
        <div fxLayout="row" class="detail">{{currentInvite.name}}</div>
    </div>
    <div class="section" fxLayout="column">
        <div fxLayout="row" class="label">Email</div>
        <div fxLayout="row" class="detail">{{currentInvite.email}}</div>
    </div>

    <div class="section" fxLayout="row">
        <div fxLayout="column" fxFlex="45%">
            <div fxLayout="row" class="label">Date Sent</div>
            <div fxLayout="row" class="detail">{{formatDate(currentInvite.createdDate)}}</div>
        </div>
        <div fxLayout="column" fxFlex="45%">
            <div fxLayout="row" class="label">Expiration Date</div>
            <div fxLayout="row" class="detail">{{formatDate(currentInvite.expDate)}}</div>
        </div>
    </div>
</div>
<div *ngIf="!currentInvite && !creating">
    Integration Invite has not yet been sent for {{integrationName}}
</div>